<template>
  <b-form-group
    :label='label'>
    <b-form-select
      :name='name'
      :options='listaCondicaoPagamentos'
      v-model='valor' />
  </b-form-group>
</template>

<script>
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group'
import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select'
import InputBaseMixins from '@/components/inputs/mixins/InputBaseMixins'

export default {
  name: 'InputCondicaoPagamentos',
  mixins: [InputBaseMixins],
  components: {
    bFormGroup,
    bFormSelect,
  },
  data() {
    return {
      listaCondicaoPagamentos: [
        { value: 'dinheiro', text: 'Dinheiro' },
        { value: 'cartao', text: 'Cartão' },
      ],
    }
  },
}

</script>
